import {createContext, ReactNode, useContext} from 'react';

import {TileSpan} from './dashboardModel';

const TileSpanContext = createContext<TileSpan | undefined>(undefined);
const TileEditChromeContext = createContext<boolean>(false);

export const TileSpanProvider = ({span, children}: {span: TileSpan; children: ReactNode}) => (
  <TileSpanContext.Provider value={span}>{children}</TileSpanContext.Provider>
);

export const TileEditChromeProvider = ({children}: {children: ReactNode}) => (
  <TileEditChromeContext.Provider value={true}>{children}</TileEditChromeContext.Provider>
);

/**
 * Resolved footprint for tile *content* to adapt its layout (e.g. drop a
 * sub-label when only 1 row tall, show more rows when taller). Falls back to the
 * passed default when no provider is present (e.g. tiles rendered outside the
 * dashboard grid).
 */
export const useTileSpan = (fallback: TileSpan = {cols: 1, rows: 1}): TileSpan =>
  useContext(TileSpanContext) ?? fallback;

export const useTileEditEmbedded = (): boolean => useContext(TileEditChromeContext);
